import React, {useEffect, useState, useRef} from 'react';

import {
    Button,
    ListGroupItem,
    ListGroup,
    Row,
    Col,
    Container,
    Navbar,
    NavbarBrand,
    Card,
    CardHeader,
    CardBody,
    Form,
    FormGroup,
    InputGroup,
    Input,
    InputGroupText,
    InputGroupAddon
} from "reactstrap";

import {
    BodyInfo,
    OtherInfo
} from "./components"

import "./components/style.scss";

import {
    historyService,
    permissionsService,
    userService,
} from "services";
import { useApi } from "hooks";

import ConfirmDialog from 'components/ConfirmDialog/ConfirmDialog';

import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    FormControlLabel,
    Modal,
    Fade,
    Backdrop,
    makeStyles
} from '@material-ui/core';
import {ExpandMore} from '@material-ui/icons';
import {DangerAlert} from '../components/custom/alerts/index'
import CreatePermission from './create';
import LoaderBox from '../components/custom/loader/loaderBox';
import NotifyComponent, { showNotify } from "components/notifications/notify";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        borderRadius: '10px',
        width: '40vw',
        minHeight: '25vh',
        height: 'auto',
        overflow: 'hidden'
    },
}));

const ListPermissions = () => {
    const {
        data: permissionsState = [],
        loading,
        execute: fetchPermissions,
    } = useApi(permissionsService.list);
    const [registerState, setRegisterState] = useState(false);
    const [permissaoParaExcluir, setPermissaoParaExcluir] = useState(null);
    const notifyRef = useRef(null);

    const handleConfirmDelete = () => {
        if (permissaoParaExcluir) {
            permissionsService
                .remove(permissaoParaExcluir.idPermission)
                .then(() => {
                    const historicData = {
                        page: "Permissions",
                        before: `Permission name: "${permissaoParaExcluir.name}"`,
                        after: "Deleted this permission.",
                        action: "delete",
                    };

                    historyService
                        .create(historicData)
                        .then(() => {
                            fetchPermissions().catch(console.error);
                            showNotify(notifyRef, "Sucesso", "Permissão excluída com sucesso.", "success");
                        })
                        .catch(console.error);
                })
                .catch(console.error)
                .finally(() => {
                    setPermissaoParaExcluir(null);
                });
        }
    };

    const handleCancelDelete = () => {
        setPermissaoParaExcluir(null);
    };

    useEffect(() => {
        let abortController = new AbortController();
        fetchPermissions().catch(console.error);
        return () => abortController.abort();
    }, [fetchPermissions]);

    const openRegister = () => setRegisterState(true);
    const closeRegister = () => {
        fetchPermissions().catch(console.error);
        setRegisterState(false);
    };

    const PageItem = ({post}) => {
        const pageData = post.split('.');
        const pagePermissions = pageData[1];

        const [pageState, setPagesState] = useState([]);

        useEffect(() => {
            let abortController = new AbortController();
            const getPage = async () => {
                try {
                    permissionsService.getPageById(pageData[0]).then((response) => {
                        return setPagesState(response.data);
                    }).catch(console.error);
                } catch (error) {
                    console.error(error);
                }
            }
            getPage();
            return () => abortController.abort();
        }, [pageData[0]]);

        return (
            <ListGroupItem style={{
                width: "100%",
                height: "auto",
                minHeight: "70px",
                padding: "10px",
                marginBottom: '10px',
                overflow: "hidden",
                borderRadius: '0.5rem',
                border: '1px solid #e9ecef',
                boxShadow: "0 1px 3px rgba(50, 50, 93, 0.1)"
            }}>
                <div style={{
                    width: "100%",
                    fontSize: "1.0em",
                    boxSizing: "border-box",
                    padding: "3px 10px",
                    marginBottom: "5px"
                }}>
                    <span style={{fontWeight: "bold"}}>Page:</span> {pageState.name}
                </div>
                <div style={{
                    display: "flex",
                    justifyContent: "space-around"
                }}>
                    <div className="custom-control custom-checkbox">
                        <input
                            className="custom-control-input"
                            type="checkbox"
                            disabled="true"
                            checked={pagePermissions ? pagePermissions.includes('v') : false}
                        />
                        <label className="custom-control-label">
                            View
                        </label>
                    </div>
                    <div className="custom-control custom-checkbox">
                        <input
                            className="custom-control-input"
                            type="checkbox"
                            disabled="true"
                            checked={pagePermissions ? pagePermissions.includes('c') : false}
                        />
                        <label className="custom-control-label">
                            Create
                        </label>
                    </div>
                    <div className="custom-control custom-checkbox">
                        <input
                            className="custom-control-input"
                            type="checkbox"
                            disabled="true"
                            checked={pagePermissions ? pagePermissions.includes('e') : false}
                        />
                        <label className="custom-control-label">
                            Edit
                        </label>
                    </div>
                    <div className="custom-control custom-checkbox">
                        <input
                            className="custom-control-input"
                            type="checkbox"
                            disabled="true"
                            checked={pagePermissions ? pagePermissions.includes('d') : false}
                        />
                        <label className="custom-control-label">
                            Delete
                        </label>
                    </div>
                </div>
            </ListGroupItem>
        )
    }

    const PermissionItem = ({post}) => {
        const classes = useStyles();
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);

        const [dangerAlert, setDangerAlert] = useState({
            status: false,
            message: ""
        });
        const openDangerAlert = (msg = "DANGER!!!") => setDangerAlert({status: true, message: msg});
        const closeDangerAlert = () => setDangerAlert({status: false});

        const postDate = post.createdAt.split('-');
        const localDate = `${postDate[2]}/${postDate[1]}/${postDate[0]}`

        const pageData = post.idPages.split(',');

        const EditPermissionsModal = () => {
            const permissionsState = {
                "name": "",
                "idPages": ""
            }
            const [pagesState, setPagesState] = useState([]);

            useEffect(() => {
                let abortController = new AbortController();
                const getPages = async () => {
                    permissionsService.listPages().then((response) => {
                        setPagesState(response.data);
                    }).catch(console.error);
                }
                getPages();
                return () => abortController.abort();
            }, [pageData]);

            const PageInput = ({post, data}) => {
                let pageData = ['-2'];
                data.forEach((page) => {
                    if (page.includes(post.idPage)) pageData = page;
                });
                if (pageData[0] !== '-2') pageData = pageData.split('.');

                const [expanded, setExpanded] = useState('');
                const handlerExpand = (e) => {
                    const crud = ['view', 'create', 'edit', 'delete'];

                    if ((e.target.id).toLowerCase() === "admin") {
                        const inputPages = [].slice.call(document.getElementsByClassName('pageInput'));
                        if (e.target.checked === true) {
                            inputPages.forEach((page) => {
                                page.checked = true;
                                if (page.id !== "admin") page.disabled = true

                                crud.forEach((option) => {
                                    const optionCheck = document.getElementById(page.id + option);
                                    optionCheck.checked = true;
                                });
                            });
                        } else {
                            inputPages.forEach((page) => {
                                page.checked = false;
                                if (page.id !== "admin") page.disabled = false
                                crud.forEach((option) => {
                                    const optionCheck = document.getElementById(page.id + option);
                                    optionCheck.checked = false;
                                });
                            });
                        }
                    } else {
                        if (e.target.checked) {
                            setExpanded('');
                            crud.forEach((option) => {
                                const optionCheck = document.getElementById(e.target.id + option);
                                optionCheck.disabled = false;
                                optionCheck.checked = true;
                            });
                        } else {
                            setExpanded('');
                            crud.forEach((option) => {
                                const optionCheck = document.getElementById(e.target.id + option);
                                optionCheck.checked = false;
                                optionCheck.disabled = true;
                            });
                        }
                    }
                }

                return (
                    <div style={{
                        width: "100%",
                        minHeight: "70px",
                        height: "auto",
                        borderRadius: "0.5rem",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 1px 3px rgba(50, 50, 93, 0.15)",
                        border: "1px solid #e9ecef",
                        marginBottom: "10px"
                    }}>
                        <div style={{
                            width: "100%",
                            borderRadius: "10px",
                            alignItems: "center",
                            overflow: 'hidden'
                        }}>
                            <Accordion expanded={expanded} style={{
                                width: "100%",
                                minHeight: "10px",
                                height: 'auto',
                                boxShadow: "none"
                            }}>
                                <AccordionSummary style={{ borderBottom: "1px solid #e9ecef" }}>
                                    <div className="col ml--2">
                                        <h4 className="mb-0" style={{textTransform: "uppercase"}}>
                                            {post.name}
                                        </h4>
                                    </div>
                                    <FormControlLabel
                                        onClick={(event) => event.stopPropagation()}
                                        onFocus={(event) => event.stopPropagation()}
                                        style={{margin: '0'}}
                                        control={
                                            <Col className="col-auto" style={{padding: '0'}}>
                                                <label className="custom-toggle">
                                                    <input type="checkbox" onChange={handlerExpand} value={post.idPage}
                                                           className="pageInput" id={post.name}/>
                                                    <span
                                                        className="custom-toggle-slider rounded-circle"
                                                        data-label-off="No"
                                                        data-label-on="Yes"
                                                    />
                                                </label>
                                            </Col>
                                        }
                                    />
                                </AccordionSummary>
                                <AccordionDetails style={{backgroundColor: "#fcfcfc", userSelect: "none"}}>
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-around"
                                    }}>
                                        <div className="custom-control custom-checkbox">
                                            <input
                                                className="custom-control-input"
                                                id={post.name + "view"}
                                                type="checkbox"
                                                value="v"
                                                disabled="true"
                                            />
                                            <label className="custom-control-label" htmlFor={post.name + "view"}>
                                                View
                                            </label>
                                        </div>
                                        <div className="custom-control custom-checkbox">
                                            <input
                                                className="custom-control-input"
                                                id={post.name + "create"}
                                                type="checkbox"
                                                value="c"
                                                disabled="true"
                                            />
                                            <label className="custom-control-label" htmlFor={post.name + "create"}>
                                                Create
                                            </label>
                                        </div>
                                        <div className="custom-control custom-checkbox">
                                            <input
                                                className="custom-control-input"
                                                id={post.name + "edit"}
                                                type="checkbox"
                                                value="e"
                                                disabled="true"
                                            />
                                            <label className="custom-control-label" htmlFor={post.name + "edit"}>
                                                Edit
                                            </label>
                                        </div>
                                        <div className="custom-control custom-checkbox">
                                            <input
                                                className="custom-control-input"
                                                id={post.name + "delete"}
                                                type="checkbox"
                                                value="d"
                                                disabled="true"
                                            />
                                            <label className="custom-control-label" htmlFor={post.name + "delete"}>
                                                Delete
                                            </label>
                                        </div>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </div>
                );
            }

            const executeCreate = (e) => {
                e.preventDefault();
                let permissions = "";

                const inputPages = [].slice.call(document.getElementsByClassName('pageInput'));

                inputPages.forEach((input) => {
                    if (input.checked === true) {
                        const crud = ['view', 'create', 'edit', 'delete'];
                        let subPermissions = "";
                        crud.forEach((option) => {
                            const optionCheck = document.getElementById(input.id + option);
                            if (optionCheck.checked === true) {
                                subPermissions += optionCheck.value;
                            }
                        });
                        permissions += `${input.value}.${subPermissions},`;
                    }
                });

                permissions = permissions.slice(0, permissions.length - 1);
                if (permissions === "") {
                    showNotify(notifyRef, "Atenção", "Selecione alguma permissão.", "warning");
                    return;
                }

                permissionsState.name = document.getElementById('name').value;
                permissionsState.idPages = permissions


                permissionsService.update(post.idPermission, permissionsState).then(() => {
                    let historicData = {
                        page: "Permissions",
                        before: null,
                        after: null,
                        action: null,
                        SO: null,
                        so: []
                    }

                    if(post.name !== permissionsState.name) historicData.so.push({
                        before: `Old permission name: "${post.name}"`,
                        after: `New permission name: "${permissionsState.name}"`,
                        action: "update"
                    });

                    if(String(post.idPages) !== String(permissionsState.idPages)) {
                        const newPermissionPagesID = permissionsState.idPages.split(",").map((idPage) => idPage.split(".")[0]);
                        const newPermissionPagesNames = newPermissionPagesID.map((permissionPage) => pagesState.filter((page) => page.idPage === parseInt(permissionPage)).map((page) => page.name).shift());

                        const oldPermissionPagesID = post.idPages.split(",").map((idPage) => idPage.split(".")[0]);
                        const oldPermissionPagesNames = oldPermissionPagesID.map((permissionPage) => pagesState.filter((page) => page.idPage === parseInt(permissionPage)).map((page) => page.name).shift());

                        historicData.so.push({
                            before: `Old permissions pages: "${oldPermissionPagesNames.join(", ")}"`,
                            after: `New permissions pages: "${newPermissionPagesNames.join(", ")}" for permission: ${permissionsState.name}`,
                            action: "update"
                        });
                    }

                    const historicBody = historicData.so.shift();
                    if (historicBody) {
                        historicData.before = historicBody.before;
                        historicData.after = historicBody.after;
                        historicData.action = historicBody.action;
                    } else {
                        return handleClose();
                    }

                    historyService.create(historicData)
                        .then(() => {
                            showNotify(notifyRef, "Sucesso", "Permissão atualizada com sucesso.", "success");
                            fetchPermissions().catch(console.error);
                            handleClose();
                        })
                        .catch((error) => {
                            console.error(error);
                            console.log(historicData);
                        });
                }).catch(console.error);

            }

            return (
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <div className={classes.paper}>
                            <Navbar className="navbar-horizontal navbar-dark bg-default" expand="lg" style={{
                                width: '100%',
                                height: '50px'
                            }}>
                                <Container>
                                    <NavbarBrand style={{cursor: 'default', userSelect: 'none'}}>
                                        Edit Permission
                                    </NavbarBrand>
                                    <Button color="danger" size="sm" type="button" onClick={handleClose}>
                                        Close
                                    </Button>
                                </Container>
                            </Navbar>
                            <CardBody className="px-lg-5 py-lg-5" style={{borderBottom: "0.5px solid #DFDFDF"}}>
                                <Form role="form" onSubmit={executeCreate}>
                                    <FormGroup>
                                        <InputGroup className="input-group-merge input-group-alternative mb-3">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="ni ni-hat-3"/>
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input
                                                placeholder="Name:"
                                                type="text"
                                                id="name"
                                                required
                                                defaultValue={post.name}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                    <div style={{
                                        width: '100%',
                                        height: "300px",
                                        display: "flex",
                                        flexWrap: "wrap",
                                        justifyContent: 'space-around',
                                        overflow: "auto",
                                        boxSizing: "border-box",
                                        padding: "5px"
                                    }}>
                                        <div style={{
                                            width: '220px'
                                        }}>
                                            {pagesState.map((data, index) => (
                                                <PageInput key={`pageinput-${index}`} post={data} data={pageData}/>))}
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <Button className="mt-4" color="primary" type="submit">
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            </CardBody>
                        </div>
                    </Fade>
                </Modal>
            );
        }

        const ConfirmDeleteModal = (e) => {
            permissionsService
                .listUserPermissions({ idPermission: post.idPermission })
                .then(async (response) => {
                    if (response.data.length > 0) {
                        e.target.disabled = true;
                        Promise.all(
                            response.data.map((permissionUser) =>
                                userService.getById(permissionUser.idUser),
                            ),
                        )
                            .then((users) => {
                                const mappedUsers = users.map((user) => user.data);
                                const namesData = mappedUsers.map((user) =>
                                    user.first_name !== undefined
                                        ? `${user.first_name} ${user.last_name}`
                                        : user.username,
                                );
                                openDangerAlert(
                                    `Users are using this permission. (${namesData.length})`,
                                );
                            })
                            .catch(console.error);
                    } else {
                        setPermissaoParaExcluir(post);
                    }
                })
                .catch(console.error);
        };


        return (
            <ListGroupItem>
                <Accordion style={{
                    width: "100%",
                    height: "inherit",
                    borderRadius: '0.5rem',
                    overflow: 'hidden',
                    border: '1px solid #e9ecef',
                    boxShadow: '0 1px 3px rgba(50, 50, 93, 0.15)'
                }}>
                    <AccordionSummary expandIcon={<ExpandMore/>} style={{ borderBottom: "1px solid #e9ecef" }}>
                        <div className="col ml--2">
                            <h4 className="mb-0">
                                {post.name}
                            </h4>
                        </div>
                        <FormControlLabel
                            onClick={(event) => event.stopPropagation()}
                            onFocus={(event) => event.stopPropagation()}
                            style={{margin: '0'}}
                            control={
                                <Col className="col-auto" style={{padding: '0'}}>
                                    <Button color="success" outline size="sm" type="button" onClick={handleOpen}>
                                        Edit
                                    </Button>
                                    <EditPermissionsModal/>
                                </Col>
                            }
                        />
                        <FormControlLabel
                            onClick={(event) => event.stopPropagation()}
                            onFocus={(event) => event.stopPropagation()}
                            style={{margin: '0'}}
                            control={
                                <Col className="col-auto" style={{padding: '5'}}>
                                    <Button color="danger" outline size="sm" type="button" onClick={ConfirmDeleteModal}>
                                        Delete
                                    </Button>
                                </Col>
                            }
                        />
                    </AccordionSummary>
                    <AccordionDetails style={{backgroundColor: "#f8f9fe", borderTop: "1px solid #e9ecef"}}>
                        <BodyInfo>
                            {pageData.map((post, index) => (<PageItem key={`pagedataitem-${index}`} post={post}/>))}
                            <OtherInfo style={{
                                width: '100%',
                                height: '1ch',
                                textAlign: 'center',
                                color: '#fff'
                            }}>
                                <span style={{fontWeight: "bold"}}>Created:</span> {localDate}
                            </OtherInfo>
                        </BodyInfo>
                    </AccordionDetails>
                </Accordion>
                <DangerAlert
                    open={dangerAlert.status}
                    onClose={closeDangerAlert}
                    message={dangerAlert.message}/>
            </ListGroupItem>
        )
    }

    return (
        <div className="content">
            <ConfirmDialog
                isOpen={!!permissaoParaExcluir}
                title="Atenção"
                message="Tem certeza que deseja excluir esta permissão?"
                onConfirm={handleConfirmDelete}
                onCancel={handleCancelDelete}
            />
            {/* Sem ele o notifyRef fica vazio e o showNotify quebra a tela (#14). */}
            <NotifyComponent notifyRef={notifyRef} />
            <Container fluid>
                <Row className="mb-4 align-items-center">
                    <Col md="8">
                        <h2 className="mb-0 text-dark" style={{ fontWeight: "700" }}>
                            <i className="ni ni-key-25 text-primary mr-2" />
                            Configuração de Perfis de Acesso
                        </h2>
                        <p className="text-muted mb-0 small">Gerencie as permissões e níveis de visualização para cada página do sistema.</p>
                    </Col>
                    <Col md="4" className="text-right">
                        {registerState ? (
                            <Button color="secondary" outline onClick={closeRegister} size="sm" type="button" className="px-4">
                                Voltar para Lista
                            </Button>
                        ) : (
                            <Button color="primary" onClick={openRegister} size="sm" type="button" className="px-4 shadow-sm">
                                <i className="ni ni-fat-add mr-1" />
                                Nova Permissão
                            </Button>
                        )}
                    </Col>
                </Row>

                <Row>
                    <Col>
                        {registerState ? (
                            <Card className="shadow-sm border-0">
                                <CardBody>
                                    <CreatePermission closeCreate={closeRegister} notifyRef={notifyRef}/>
                                </CardBody>
                            </Card>
                        ) : (
                            <Card className="shadow-sm border-0">
                                <CardHeader className="bg-transparent border-0 py-3">
                                    <h4 className="mb-0 text-muted font-weight-600">Perfis Ativos</h4>
                                </CardHeader>
                                <CardBody className="p-0">
                                    {loading ? (
                                        <div className="py-5 text-center">
                                            <LoaderBox/>
                                        </div>
                                    ): (
                                        <div className="px-3 pb-3">
                                            <ListGroup className="list" flush style={{
                                                width: '100%',
                                                borderRadius: '0.5rem',
                                                overflow: 'hidden',
                                                border: '1px solid #e9ecef',
                                                maxHeight: '65vh',
                                                overflowY: 'auto'
                                            }}>
                                                {permissionsState.length > 0 ? permissionsState.map((post, index) => (
                                                    <PermissionItem key={`permission-${index}`} post={post}/>)) : (
                                                    <div className="text-center py-5">
                                                        <i className="ni ni-lock-circle-open display-3 text-muted opacity-3 mb-3" />
                                                        <h4 className="text-muted">Nenhuma permissão cadastrada.</h4>
                                                    </div>
                                                )}
                                            </ListGroup>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default ListPermissions;
